/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatFirestoreTimeStamp } from "utils";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Text from "components/Common/Text";
import HeaderIndicator from "components/Common/Header/sub/HeaderIndicator";

const accordionVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1, // Динамическая задержка

      ease: "easeOut", // Плавный выход
      type: "spring", // Используем spring для более плавного движения
    },
  }),
};

export function EventList({ events, dogPound }) {
  if (events?.length <= 0) {
    return (
      <Text
        as="H4"
        bold
        style={{
          color: "black",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f3f3f3",
          width: "100%",
          padding: 14,
          borderRadius: 14,
          marginBottom: 8,
        }}
      >
        No Events Live Today
      </Text>
    );
  }
  return (
    <div
      style={{
        padding: "24px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          fontWeight: "700",
          marginBottom: "20px",
          color: "#333",
          textAlign: "center",
        }}
      >
        Big Game Events
      </h2>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          display: "grid",
          gap: "16px",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        {events.length >= 1 ? (
          events?.map((event) => {
            const dateStr = formatFirestoreTimeStamp(
              event.timestamp,
              "EEEE, MM/dd",
            );

            return (
              <Link
                to={`/dogpound/${event.id}/finalScorecard`}
                key={event.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#f3f3f3",
                  width: "100%",
                  padding: 14,
                  borderRadius: 14,
                  marginBottom: 8,
                }}
              >
                <Text as="H4" style={{ color: "black" }}>
                  {dateStr} Big Game
                </Text>
                <Text as="P3" style={{ color: "black" }}>
                  {event.title}
                </Text>

                <Text as="P3" style={{ color: "black" }}>
                  Created by {event.createdBy.lastName}
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 4,
                    marginTop: 4,
                  }}
                >
                  <HeaderIndicator
                    live={event?.teeTimesSubmitted?.length <= 0}
                  />
                </div>
              </Link>
            );
          })
        ) : (
          <Text
            as="H4"
            bold
            style={{
              color: "black",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f3f3f3",
              width: "100%",
              padding: 14,
              borderRadius: 14,
              marginBottom: 8,
            }}
          >
            No Events Live Today
          </Text>
        )}
      </ul>
    </div>
  );
}

EventList.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      courseName: PropTypes.string.isRequired,
      teeName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  dogPound: PropTypes.bool,
};

EventList.defaultProps = {
  dogPound: false,
};
